/**
 * WB-PP-11 / WB-SA-09: strip dangerous HTML from Quill / rich-text before persist or display.
 * Keeps intended formatting tags; removes script/iframe and event-handler attributes.
 */
export function sanitizeRichHtml(html) {
  if (!html || typeof html !== 'string') return html || '';
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
      .replace(/on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
      .replace(/javascript:/gi, '');
  }
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc
      .querySelectorAll('script, iframe, object, embed, link[rel="import"]')
      .forEach((el) => el.remove());
    doc.querySelectorAll('*').forEach((el) => {
      [...el.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const val = String(attr.value || '');
        if (name.startsWith('on') || /javascript:/i.test(val)) {
          el.removeAttribute(attr.name);
        }
      });
    });
    return doc.body.innerHTML;
  } catch {
    return '';
  }
}

export default sanitizeRichHtml;
